import type { SheetConnector } from './sheet-connector'

/** Mirrors backend/web/src/graph/dto/connected-graphs-response.dto.ts */

export interface ConnectedPage {
  page: number
  graph_id: string
  is_current: boolean
}

export interface ConnectedSibling {
  document_id: string
  name: string | null
  graph_id: string | null
  sheet_index: number
  is_current: boolean
}

export interface ConnectedConnection {
  source_node_id: string
  source_label: string | null
  // Backend derives only 'inlet' / 'outlet' (or null); narrow so the panel's
  // arrow rendering is exhaustive and typos fail at compile time.
  direction: 'inlet' | 'outlet' | null
  note: string | null
  connected_graph_id: string
  connected_node_id: string | null
  connected_document_id: string | null
  connected_document_name: string | null
  connected_page: number | null
}

export interface ConnectedGraphsResponse {
  graph_id: string
  document_id: string | null
  document_name: string | null
  pages: ConnectedPage[]
  siblings: ConnectedSibling[]
  connections: ConnectedConnection[]
  manual_connectors: SheetConnector[]
}

/**
 * True when this drawing is actually CONNECTED to another one — a detected
 * cross-drawing connection or a manual connector.
 *
 * Sibling pages/sheets deliberately do NOT count. A multi-page PDF whose pages
 * share nothing but a file, or a set whose members were grouped by hand, is not
 * "connected"; showing the entry point for those made the button near-permanent
 * and told the user there were connections to inspect when there were none.
 * Moving between those pages is the sheet page bar's job (FS-654), not this
 * panel's — which is what freed this predicate to mean what its name says.
 */
export function hasConnectedPnids(data: ConnectedGraphsResponse | null | undefined): boolean {
  if (!data) return false
  return data.connections.length > 0 || data.manual_connectors.length > 0
}
